// What's New — REAL release notes, written by hand for each notable release:
// bump RELEASE_VERSION so the dialog shows itself to everyone once (AppLayout
// compares it with SEEN_KEY in localStorage). Only what is live on the site
// goes in, in the trader's words. Past releases would go to PREVIOUS_RELEASES;
// the changelog button stays hidden while it is empty. The July 2026 notes
// were not moved there: they described the v8 look and panels that Soft has
// since replaced, so they no longer describe the product.

/** Bumping this re-arms the once-per-release auto-show. Drives the header chip. */
export const RELEASE_VERSION = 'November 2026'

/** localStorage key holding the last version the user dismissed. */
export const SEEN_KEY = 'wt:whatsnew:seen'

/** Which built-in illustration a slide renders (full preview + small thumb). */
export type SlideMedia = 'chart' | 'columns' | 'bars' | 'rewards'

/** Which feature glyph sits in the slide's media pill. */
export type SlideIcon = 'bolt' | 'pulse' | 'portfolio' | 'gift'

export interface WhatsNewSlide {
  /** media pill label */
  pill: string
  icon: SlideIcon
  media: SlideMedia
  title: string
  body: string
}

export interface Release {
  /** header chip text (calendar tag, not a made-up semver). */
  version: string
  date: string
  // Non-empty tuple so slides[0] is a sound fallback under noUncheckedIndexedAccess.
  slides: [WhatsNewSlide, ...WhatsNewSlide[]]
}

export const CURRENT_RELEASE: Release = {
  version: RELEASE_VERSION,
  date: 'November 5',
  slides: [
    {
      pill: 'New look',
      icon: 'bolt',
      media: 'columns',
      title: 'A softer, calmer terminal',
      body: 'Discover, Trenches, the token page, Portfolio and the wallet windows share one quiet design, with figures and labels lined up on every screen.',
    },
    {
      pill: 'Live Holders',
      icon: 'pulse',
      media: 'bars',
      title: 'Live Holders and Top traders',
      body: 'Rows update as trades land, with no refresh. A holder who sells out leaves the list, and Top traders covers 1D, 7D, 30D and All.',
    },
    {
      pill: 'Portfolio',
      icon: 'portfolio',
      media: 'chart',
      title: 'Your PnL, three ways',
      body: 'Switch between total, unrealized and realized PnL, see each day on the PnL calendar, and show every figure in GRAM or USD.',
    },
    {
      pill: 'Any wallet',
      icon: 'portfolio',
      media: 'columns',
      title: "Open any wallet's portfolio",
      body: 'Click a holder or a top trader to see their holdings and PnL on the same Portfolio page as your own.',
    },
    {
      pill: 'Chart',
      icon: 'pulse',
      media: 'chart',
      title: 'A steadier chart',
      body: 'Zoom holds the bar under your cursor, the live candle keeps moving while you zoom or pan, and older history loads before you reach it.',
    },
    {
      pill: 'Rewards',
      icon: 'gift',
      media: 'rewards',
      title: 'Rewards for trading',
      body: 'Earn points on your trades, complete daily quests and achievements, and invite friends with your referral link.',
    },
    {
      pill: 'Sounds',
      icon: 'bolt',
      media: 'bars',
      title: 'Hear your trades',
      body: 'A short sound when a trade fills or fails, a limit order fills or a price alert fires. Tune or mute it from the sound button in Trenches.',
    },
  ],
}

export const PREVIOUS_RELEASES: Release[] = []
